import React, { useContext, useState } from "react";
const MenuContext = React.createContext();

export function useMenu() {
    return useContext(MenuContext);
}

export function MenuProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);

    function onMenuOpen() {
        setIsOpen(true);
    }

    function onMenuClose() {
        setIsOpen(false);
    }

    const value = {
        onMenuOpen,
        onMenuClose,
        isOpen
    };

    return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
}

export default MenuContext;